import { Injectable } from '@angular/core';
import { BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  
  loading = new BehaviorSubject<boolean>(false);
  ignore_loading = false;
  constructor() { }

  setLoading(loading: boolean) {
    if (!this.ignore_loading) {
      this.loading.next(loading);
    }
  }

  public loginStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  setLoggedInStatus(value: boolean) {
      this.loginStatus.next(value);
  }

}